// @flow
import React, { type Node } from 'react';
import { PaynetPaymentLocation } from './paynet-payment-location';

export function PaynetForm():Node {
  return (
    <PaynetPaymentLocation />
  );
}
